import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import React from "react";
import { getCityStateCountry } from "shared/utils/addressUtils";

interface Props {
  billingDetails: server.dto.ClientBillingDetails
}

const AddressRow = (props: Props) => (
  <CardRowSegment className="margin-bottom" type="lined">
    <div>
      <div>
        <strong>{props.billingDetails.company.name}</strong>
      </div>
      <div>
        {getCityStateCountry(props.billingDetails.company.address)}
      </div>
    </div>
  </CardRowSegment>);

export default AddressRow;